import React, { createRef, useEffect, useRef, useState } from "react";
import inventoryCounts from "../jsonObjects/inventoryCounts.json";
import { InventoryTable } from "../components/inventoryTable";
import { SearchPanel } from "../components/SearchPanel";
import { AddView } from "../components/AddView";

export function Inventory(props) {
  const [selectedRow, setSelectedRow] = useState(props.activeCount || null);
  const [counts, setCounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [addView, setAddView] = useState(false);

  const fetchData = () => {
    fetch(
      `https://inventy.redata.se/inventdb/api_inventoryCounts.php?Command=GetCount`,
    )
      .then((response) => response.json())
      .then((data) => {
        setCounts(data);
        console.log(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setCounts([]); // Set products to an empty array on error
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    if (props.activeCount === "new") {
      setAddView(true);
      setSelectedRow(null);
      props.setActiveCount(null);
    }
  }, []);

  const handleRowSelection = (rowId) => {
    setSelectedRow(selectedRow === rowId ? null : rowId);
  };

  useEffect(() => {}, [selectedRow]);

  if (loading) {
    return <div>Loading...</div>;
  }

  function newCount() {
    const allClosed = Object.keys(counts).every((year) =>
      Object.values(counts[year]).every((item) => item.active == 0),
    );
    if (allClosed) {
      setAddView(true);
    } else {
      alert("Kan inta ha mer än 1 aktiv inventering");
    }
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <SearchPanel setSearch={setSearch} />

        <div className="SearchPanel">
          {localStorage.getItem("Admin") === "1" && (
            <button className="hoverButton" onClick={newCount}>
              Ny inventering
            </button>
          )}
        </div>
      </div>
      {Object.keys(counts).map((year) => (
        <InventoryTable
          key={year}
          Title={year}
          Data={counts[year]}
          handleRowSelection={handleRowSelection}
          selectedRow={selectedRow}
          search={search}
          refresh={fetchData}
        />
      ))}
      {addView && (
        <AddView
          type="Inventory"
          setAddView={setAddView}
          setSelected={setSelectedRow}
          refresh={fetchData}
        />
      )}
    </div>
  );
}
